// extracted by mini-css-extract-plugin
export default {"root":"RefundPolicy-module__root___38T0V"};